/** API route map: URLS.Controller.EmployeeNotes */
export const EmployeeNotes = {
      Name: 'EmployeeNotes/',
      GetAll: 'employee-notes',
      AddNote: 'add-employee-note',
      UpdateEmployeeNote: 'update',
      DeleteEmployeeNote: 'delete/',
};
